import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.14_db0@0.3.2_e_7b4b3ecf1c8dd06be30ffb8194ead0f5/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.14__e74155461a72bca4a0a50e71b19ff5cb/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}